export default {
  docurl: 'https://www.truenas.com/docs/',
};
